<template>
  <CartItemProduct v-if="isProduct" :line="line" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { LiquidLineItem } from '../../types/liquid'
import CartItemProduct from './CartItemProduct.vue'

const props = defineProps<{
  line: LiquidLineItem
}>()

const isProduct = computed(() => !props.line.properties.Product)
</script>

<style lang="scss">
@import '~styles/base.scss';
</style>
